import { io } from "socket.io-client";

let serverUrl = process.env.REACT_APP_SERVER_URL || "http://localhost:3007";
let serverPath = ""
let socketPath = 'socket.io';

// Check if the URL contains a path segment after the domain
const urlParts = serverUrl.match(/(https?:\/\/[^\/]+)(\/.*)?/);
if (urlParts && urlParts[2]) {
    // Extract the base URL and append the path to the socket.io path
    serverUrl = urlParts[1];
    serverPath = urlParts[2];
}
if (serverUrl[-1] !== "/" && serverPath[0] !== "/") serverPath = "/" + serverPath;
socketPath = serverPath + socketPath;
console.log("serverUrl", serverUrl)
console.log("socketPath", socketPath)

export const socket = io(serverUrl, { path: socketPath, autoConnect: false });

export const authenticate = (sessionRunId: string) => {
    socket.emit("authenticate", { token: localStorage.getItem("token"), sessionRunId });
}

socket.on("connect", () => {
    console.log("Connected to socket server");
});

socket.on("disconnect", () => {
    console.log("Disconnected from socket server");
});